export * from './user.service';
export * from './user.types';

// ⛔ DO NOT add `export * from './user.email'` here (GB #1780).
//
// user.email.ts imports `mailchecker`, a ~33,000-domain disposable-email
// blocklist that is ~971 KB parsed / ~321 KB gzipped. This barrel is imported
// by AuthContext.tsx (for listenToUserDocument et al), and AuthContext is
// mounted in _app.tsx -- so anything re-exported here lands in the GLOBAL _app
// chunk and is downloaded on all 86 routes, including anonymous browsing.
//
// Re-exporting it would silently undo #1780 and every check would still pass:
// tsc, lint, and the whole unit suite stay green because nothing about the
// behaviour changes -- only the bundle graph does. That is why there is an
// explicit guard test for this line: user.email.barrelGuard.test.ts.
//
// The 7 files that need `emailSchema` import it directly from
// '@util/firestore/users/user.email'. That deep import is deliberate, not an
// oversight.
